export const ADD_PLAYLIST = "ADD_PLAYLIST";
export const SELECTED_ADD_PLAYLIST = "SELECTED_ADD_PLAYLIST";
export const ADD_TO_PLAYLIST = "ADD_TO_PLAYLIST";
